import React, { useEffect, useRef, useMemo } from "react"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import gsap from "gsap"
import { useContentfulResults } from "../../hooks/useContentfulResults"
import QuizResurfaceBanner from "../wild/nova/quizresurfacebanner/quizresurfacebanner"
import Hero from "../wild/nova/hero/hero"
import RootCauses from "../wild/nova/rootcauses/rootcauses"
import Manifesto from "../wild/nova/manifesto/manifesto"
import ProductsSection from "../wild/nova/products/productsection"
import Growth from "../wild/nova/growth/growth"
import QuizBanner from "../wild/nova/quizbanner/quizbanner"
import Results from "../wild/nova/results/results"
import DoctorQuotes from "../wild/nova/quotes/doctorquotes"
import Stats from "../wild/nova/stats/stats"
import FaqAccordion from "../wild/nova/faq-accordion"
//import PurposeScroll from "../wild/nova/purposescroll/purposescroll"
import LegalDisclaimer from "../wild/nova/legal-disclaimer"

import { data } from "../../data/homepageredesign"

gsap.registerPlugin(ScrollTrigger)

/*
 * to remove NT2-21722, BFCM hero AB test, render only Hero here
 * remove ribbon changes in wild/nova/header/header.js
 */

const HomePage = ({ cfFaqData }) => {
  const homepageWrapperRef = useRef(null)
  const timerRef = useRef(null)
  const resultsCf = useContentfulResults(data.results.uid) // Pass a single module UID

  const resizeObserver = useMemo(() => {
    if (typeof window !== "undefined") {
      return new ResizeObserver(() => {
        clearTimeout(timerRef.current)
        timerRef.current = setTimeout(() => {
          ScrollTrigger.refresh()
        }, 500)
      })
    }
    return null
  }, [])

  useEffect(() => {
    if (typeof window !== "undefined" && resizeObserver) {
      if (!homepageWrapperRef?.current) return

      resizeObserver.observe(homepageWrapperRef.current)

      return () => {
        clearTimeout(timerRef.current)
        resizeObserver.disconnect()
      }
    }
  }, [resizeObserver])

  return (
    <div ref={homepageWrapperRef}>
      <QuizResurfaceBanner />
      <Hero data={data.hero} />
      <RootCauses data={data.rootCauses} />
      {/* <PurposeScroll data={data.purposeScroll} /> */}
      <Manifesto data={data.manifesto} />
      <div id="growth-pin-wrapper">
        <ProductsSection data={data.products} />
        <Growth data={data.growth} />
        <QuizBanner />
      </div>
      <Results data={resultsCf} />
      <DoctorQuotes data={data.doctorQuotes} />
      <Stats data={data.stats} />
      <FaqAccordion data={cfFaqData} />
      <LegalDisclaimer data={data.references} />
    </div>
  )
}

export default HomePage
